import { ComponentType, default as React } from 'react'
import { ListChildComponentProps } from 'react-window'
import { format } from 'date-fns'
import name from '../../../common/name'
import Tooltip from '../../../components/Tooltip'
import { orderTotal } from '../../../common/orders'
import { IDetailsOrder } from '../../../types/orders'
import ShippingInfo from '../SubmittedOrdersRow/shippingInfo'
import TdStatus from './TdStatus'
import TdProcessingStatus from './TdProcessingStatus'

type IOrdersRow = ComponentType<ListChildComponentProps>

const OrdersRow: IOrdersRow = ({ data, index, style }) => {
  const order = data.orders[index] as IDetailsOrder
  const { allBranches, multiCatalogEnabled } = data
  const erpOrders = data.erpOrders as string | undefined
  const showProcessingStatus =
    (erpOrders === 'ipo' || order.processingStatus === 'blocked') &&
    order.status === 'submitted'

  return (
    <>
      <div style={style}>
        <div
          className="table_tr -fixed-height -link"
          onClick={() => data.onClick(order)}
        >
          <div className="table_td -g20">
            {order.submittedAt ? format(order.submittedAt, 'MMM D, YYYY') : '-'}
          </div>
          {allBranches && (
            <div className="table_td -g25">
              {order.branch ? order.branch.name : '-'}
            </div>
          )}
          <div className="table_td -g25">
            <Tooltip id={`tooltip-updated-by-${order.id}`}>
              <div
                className="input_list-tooltip"
                data-tip={
                  order.updatedAt
                    ? format(order.updatedAt, 'MMM D, YYYY HH:MM')
                    : '-'
                }
                data-for={`tooltip-updated-by-${order.id}`}
                data-effect="solid"
                data-place="bottom"
              >
                {name(order.updatedBy)}
              </div>
            </Tooltip>
          </div>
          {showProcessingStatus ? (
            <TdProcessingStatus order={order} />
          ) : (
            <TdStatus order={order} />
          )}
          {multiCatalogEnabled && (
            <div className="table_td -g20">{order.erpCatalogName || '-'}</div>
          )}
          <div className="table_td -g20">{order.navOrderId || '-'}</div>
          <div className="table_td -g20">
            {order.purchaseOrderNumber || '-'}
          </div>
          <div className="table_td -g20">{orderTotal(order)}</div>
          <div className="table_td -g25" onClick={(e) => e.stopPropagation()}>
            {erpOrders === 'ipo' && !order.navOrderId ? (
              <span>Please check Ariba for tracking on this order</span>
            ) : order.status === 'submitted' ? (
              <ShippingInfo order={order} />
            ) : (
              '-'
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default OrdersRow
